<template>
    <div>
      <a-button class="top_btn" type="primary" @click="listOrder()" > 排序</a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"
                  style="width: 60%">
           <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
                <a-switch
                @click="onChange(record)"
                :checked="text == 1 ? true : false"
                />
            </span>
            <span slot="action" slot-scope="text, record">
                <a @click="(record)=>{visibleForm = true; titleForm='编辑'; editId=text.id ; }">编辑</a>
            </span>
        </a-table>

      <filialeForm :visible="visibleForm" :title="titleForm" :editId="editId"
                   @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, orderList} from "../../../utils/utils"
    import filialeForm from "./components/filialeForm"
    const columns = [
      {
        title: "排序",
        dataIndex: "list_order",
        key: "list_order",
        width: "100px",
        scopedSlots: {customRender: "list_order"}
      },
        {
            title: "服务类型",
            dataIndex: "name",
            ellipsis: true,
            key: "name"
        },

        {
            title: "启用状态",
            dataIndex: "status",
            ellipsis: true,
            key: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                // 添加、编辑弹窗
                visibleForm: false,
                titleForm: "",
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                editId: null,
                data: [],
                columns,
              sortLists:[]
            }
        },
      components: {filialeForm},
        created() {
            this.$store.state.adminleftnavnum = "/Set/PaymentSettings"; //设置左侧导航2-2 active
        },
        methods: {
          listOrder() {
            this.getchangId(this.data)
            orderList(API.administrator.LIST_ORDER , this.sortLists).then(res => {
              this.getList()
            })
          },
          getchangId(data) {
            this.sortLists=[]
            let sortListOrder = {id: "", list_order: ""}
            for (let i = 0; i < data.length; i++) {
              sortListOrder.id = data[i].id
              sortListOrder.list_order = data[i].list_order
              this.sortLists.push(sortListOrder)
              sortListOrder = {}
              if (data[i].children && data[i].children.length > 0) {
                this.getchangId(data[i].children)
              }
            }
          },
            getList(page) {
                API.administrator.GET_DATA(page||1).then(res => {
                  this.data = res.data.data.list.data
                    this.loading = false;
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS_FILALE, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
